import {
  Globe, Cloud, ShoppingCart, Smartphone, PenTool, GraduationCap,
  Code2, Server, Layers, CloudCog, Palette,
  Award, Briefcase, Users, Calendar, Mail, ArrowRight, ArrowUpRight,
  Zap, Gem, Handshake, Rocket, Target, Telescope, MapPin, Send, CheckCircle2,
  Newspaper, AlertCircle,
} from "lucide-react";

const ICONS = {
  Globe, Cloud, ShoppingCart, Smartphone, PenTool, GraduationCap,
  Code2, Server, Layers, CloudCog, Palette,
  Award, Briefcase, Users, Calendar, Mail, ArrowRight, ArrowUpRight,
  Zap, Gem, Handshake, Rocket, Target, Telescope, MapPin, Send, CheckCircle2,
  Newspaper, AlertCircle,
};

export default function Icon({ name, size = 22, strokeWidth = 1.6, style, ...rest }) {
  const Cmp = ICONS[name];
  if (!Cmp) return null;
  return <Cmp size={size} strokeWidth={strokeWidth} style={style} {...rest} />;
}
